<template>
  <div>
    <!-- ONBOARDING DE INVERSIONISTAS -->
    <investor-onboarding-register-page v-if="isInvestor" :referal-info="referalInfo"/>
    <supplier-onboarding-register-page v-else-if="isSupplier" :referal-info="referalInfo"/>
    <applicant-onboarding-register-page v-else-if="isApplicant" :referal-info="referalInfo"/>
    <div v-else class="vx-row no-gutter items-center justify-center p-10">
      <div class="vx-col w-full sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-2/5 xxl:w-2/5 m-0">
        <vx-card class="login-card py-3 px-3">
          <div class="vx-col sm:w-full">
            <div class="pt-8 login-tabs-container">
              <div class="vx-row m-0">
                <div class="vx-col w-full p-0" style="min-height: 200px">
                  <div class="pt-5 pb-5">
                    <!-- ENCABEZADO -->
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <p class="text-2xl card-sub-title text-center mb-base">¿Qué producto deseas contratar?</p>
                        </div>
                    </div>
                    <!-- CONTENIDO -->
                    <div class="vx-row mb-4 m-0 justify-center">
                      <div @click="productSelected = 1" class="vx-col md:w-1/2 lg:w-1/3 text-center mb-base">
                        <div class="register-option mb-4" :class="{active: productSelected === 1}">
                          <img :src="investorIcon" alt="inversión" class="investor-icon">
                        </div>
                        <p>Inversión</p>
                      </div>
                      <div @click="productSelected = 2" class="vx-col md:w-1/2 lg:w-1/3 text-center mb-base">
                        <div class="register-option mb-4" :class="{active: productSelected === 2}">
                          <img :src="loanIcon" alt="crédito">
                        </div>
                        <p>Crédito</p>
                      </div>
                      <div @click="productSelected = 3" class="vx-col md:w-1/2 lg:w-1/3 text-center mb-base">
                        <div class="register-option mb-4" :class="{active: productSelected === 3}">
                          <img :src="supplierIcon" alt="crédito">
                        </div>
                        <p>Instalador solar</p>
                      </div>
                    </div>

                    <div class="vx-row">
                      <!-- <div class="vx-col w-full text-center mb-12">
                        <p class="bold clickable-img">Si deseas registrarte como instalador, <span @click.stop="goToSupplier"><u>haz clic aquí</u></span>.</p>
                      </div> -->
                      <div class="vx-col w-full md:ml-24 md:mr-24 mb-base">
                        <vs-button :disabled="productSelected == 0" @click.stop="goToOnboardingSelected" class="w-full">Continuar</vs-button>
                      </div>
                      <div class="vx-col w-full text-center">
                        <p class="bold clickable-img">¿Ya tienes una cuenta? <span @click.stop="goToLogin"><u>Da clic aqui</u></span>.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <vs-prompt
        :active.sync="activePrompt"
        title="¡Tu registro ha sido exitoso!"
        color="success"
        :buttonsHidden="true"
        type="confirm" >

        <div>
          <span v-if="isSupplier">
            Estás muy cerca de tener acceso al mejor crédito solar de México para tus clientes. <br><br>
          </span>
          <!-- TODO-DELETE 29/11/2022 el registro de inversionista se hace desde el onboarding -->
          <!-- <span v-else-if="isInvestor">
            ¡Ya estás muy cerca de comenzar a crecer tu dinero gracias a la energía limpia! <br><br>
          </span> -->
          <span class="bold">
            Te hemos enviado un correo electrónico para que actives tu cuenta y comiences tu proceso de verificación. <br><br>
          </span>
          <span>
            Si tienes alguna duda contáctanos a través del chat de la plataforma o en cualquiera de nuestras redes sociales.
          </span>
        </div>

        <footer>
          <vs-button
            color="success"
            class="vs-dialog-accept-button"
            @click="goToLogin">Finalizar</vs-button>
        </footer>
      </vs-prompt>

    </div>
  </div>
</template>

<script>
import PersonalProfileForm from "@components/register/PersonalProfileForm";
import BusinessProfileForm from "@components/register/BusinessProfileForm";
import UserDataForm from "@components/register/UserDataForm";
import SupplierDataForm from "@components/register/SupplierDataForm";
import ApplicantLeadForm from "@components/register/ApplicantLeadForm";
import InvestorOnboardingRegisterPage from "@views/investor/InvestorOnboardingRegisterPage";
import SupplierOnboardingRegisterPage from "@views/supplier/onboarding/SupplierOnboardingRegisterPage.vue";
import ApplicantOnboardingRegisterPage from "../applicant/onboarding/ApplicantOnboardingRegisterPage.vue";
const investorType = 'inversionista';
const supplierType = 'instalador';
const applicantType = 'solicitante';
export default {
  name: "RegisterFormPage",
  props: {
    type: {
      type: String
    },
    referalInfo: {
      type: Object,
      default: () => null
    }
  },
  components: {
    ApplicantLeadForm,
    PersonalProfileForm,
    BusinessProfileForm,
    SupplierDataForm,
    UserDataForm,
    InvestorOnboardingRegisterPage,
    SupplierOnboardingRegisterPage,
    ApplicantOnboardingRegisterPage
},
  async beforeMount(){
    this.isMounted = false
    this.showForm = false
    if(this.$props.type !== investorType && this.$props.type !== supplierType && this.$props.type !== applicantType){
      await this.$router.replace({name: 'infoRegistro'});
      return;
    }
    // TODO-DELETE 29/11/2022 se valida en un nivel superior RegisterFromReferalPage
    // if(this.$props.referalCode != null && this.$props.referalCode !== ""){
    //   this.fromReferal = true;
    //   this.showLoading(true)
    //   this.validReferalCode = await this.validateReferalCode();
    //   if(this.validReferalCode){
    //     this.showForm = true;
    //   }
    //   this.showLoading(false)
    // }
    // se valida que venga info del codigo de redferido
    if(this.$props.referalInfo != null){
      this.fromReferal = true;
      this.showForm = true;
    }
    else {
      this.showForm = true;
    }
    this.isMounted = true
  },
  data(){
    return {
      investorType: 'inversionista',
      supplierType: 'instalador',
      applicantType: 'solicitante',
      imgInvestorUrl: 'https://cdn.redgirasol.com/img/icons/A-02.png',
      investorIcon: 'https://cdn.redgirasol.com/nuevo_portal/icons/icon-register-investor.png',
      loanIcon: 'https://cdn.redgirasol.com/nuevo_portal/icons/icon-register-loans.png',
      supplierIcon: 'https://cdn.redgirasol.com/nuevo_portal/icons/icon-register-suppliers.png',
      accountType: null,
      supplierContractUrl: 'contrato-de-comision-mercantil-instalador',
      investorContractUrl: 'contrato-de-comision-mercantil-inversionista',
      applicantContractUrl: '',
      requiredRules: 'required',
      errorMssg: null,
      fromReferal: false,
      isMounted: false,
      showForm: false,
      // TODO-DELETE 29/11/2022 se valida en un nivel superior RegisterFromReferalPage
      // validReferalCode: false,
      contracts: {
        allContracts: null,
      },
      // TODO-DELETE 29/11/2022 se valida en un nivel superior RegisterFromReferalPage
      // referalInfo: {
      //   id: null,
      //   name: null,
      //   type: null,
      //   referal_type: null,
      // },
      activePrompt: false,
      productSelected: 0
    }
  },
  watch: {
    accountType: function(o,n){
      this.onPersonTypeChanged();
    }
  },
  computed: {
    isPersonal(){
      return this.accountType === 'fisica';
    },
    isMoral(){
      return this.accountType === 'moral';
    },
    isInvestor(){
      return this.type === investorType;
    },
    isSupplier(){
      return this.type === supplierType;
    },
    isApplicant(){
      return this.type === applicantType;
    },
    accountTypeDefined(){
      return this.accountType !== null;
    },
    terminosCondicionesUrl(){
      return 'https://www.redgirasol.com/terminos-y-condiciones';
    },
    avisoPrivacidadUrl(){
      return 'https://www.redgirasol.com/aviso-de-privacidad';
    },
    comisionMercantilUrl(){
      if (this.type === investorType){
        return `${this.ApiDomain}/${this.investorContractUrl}`;
      }
      else if (this.type === supplierType){
        return `${this.ApiDomain}/${this.supplierContractUrl}`;
      }
      else {
        return `${this.ApiDomain}/${this.applicantContractUrl}`;
      }
    },
    referalCode(){
      return this.referalInfo? this.referalInfo.uri : null;
    }
  },
  methods: {
    // TODO-DELETE 29/11/2022 se valida en un nivel superior RegisterFromReferalPage
    // async validateReferalCode(){
    //   try {
    //     const res = await this.publicApiGet(`api/v2/preregister/validateReferalCode/${this.referalCode}`);
    //     this.referalInfo = res.data.referal;
    //     return true;
    //   }
    //   catch (e) {
    //     return false;
    //   }
    // },
    onPersonTypeChanged(){
      if(this.$refs.personalProfile){
        this.$refs.personalProfile.onPersonTypeChanged();
      }
    },
    async saveRequest(){
      this.errorMssg = null;
      const valid = await this.$refs.personalProfile.validateForm();
      const valid2 = await this.$refs.userDataForm.validateForm();
      const mvalid = await this.$validator.validateAll();
      let valid3 = true;
      if(this.isMoral){
        valid3 = await this.$refs.businessProfile.validateForm();
      }

      let complete = false;
      if(valid && valid2 && valid3 && mvalid){
        const mcontracts = this.validateContracts();
        if(mcontracts){
          complete = true;
        }
      }
      if(!complete) {
        this.errorNotif("Campos pendientes", "Por favor completa los campos pendientes para poder continuar.", 5000);
        return;
      }
      // TODO-DELETE 29/11/2022 el registro de inversionista se hace desde el onboarding
      // if(this.isInvestor && this.isPersonal){
      //   await this.doRegisterInvestorPF();
      // }
      // else if(this.isInvestor && this.isMoral){
      //   await this.doRegisterInvestorPM();
      // }
      if(this.isSupplier && this.isPersonal){
        await this.doRegisterSupplierPFAE();
      }
      else if(this.isSupplier && this.isMoral){
        await this.doRegisterSupplierPM();
      }
    },
    async saveApplicantRequest(){
      this.errorMssg = null;
      const valid = await this.$refs.applicantLeadForm.validateForm();
      if(!valid) {
        return;
      }
      await this.doRegisterApplicantLead();
    },
    // registro de lead de solicitante
    async doRegisterApplicantLead(){
      this.showLoading(true)
      try {
        let payload = {
          lead: this.$refs.applicantLeadForm.getModel(),
        }
        await this.publicApiPost('/api/v2/leads/registerApplicant', payload);
        this.$refs.applicantLeadForm.resetForm();
        let mssg = "Gracias por tu interés en formar parte de la Red.\n\nEn breve, uno de nuestros agentes " +
          "se pondrá en contacto contigo.";
        this.successDialogWithAcceptCallback(this.goToLogin, "Hemos recibido tus datos", mssg, 'Finalizar');
      }
      catch (e) {
        this.showError(e);
      }
      this.showLoading(false)
    },
    // TODO-DELETE 29/11/2022 el registro de inversionista se hace desde el onboarding
    // // registro inversionista PF
    // async doRegisterInvestorPF(){
    //   this.showLoading(true, 'Realizando tu registro...')
    //   try {
    //     let payload = {
    //       user: this.$refs.userDataForm.getModel(),
    //       personal: this.$refs.personalProfile.getModel(),
    //       from_referal: this.fromReferal,
    //       referal_code: this.fromReferal ? this.referalCode : null
    //     };

    //     await this.publicApiPost('/api/v2/preregister/investorPF', payload);
    //     this.showSuccess();
    //   }
    //   catch (e) {
    //     this.showError(e);
    //   }
    //   this.showLoading(false)
    // },
    // // registro inversionista PM
    // async doRegisterInvestorPM(){
    //   this.showLoading(true, 'Realizando tu registro...')
    //   try {
    //     let payload = {
    //       user: this.$refs.userDataForm.getModel(),
    //       personal: this.$refs.personalProfile.getModel(),
    //       business: this.$refs.businessProfile.getModel(),
    //       from_referal: this.fromReferal,
    //       referal_code: this.fromReferal ? this.referalCode : null
    //     };

    //     await this.publicApiPost('/api/v2/preregister/investorPM', payload);
    //     this.showSuccess();
    //   }
    //   catch (e) {
    //     this.showError(e);
    //   }
    //   this.showLoading(false)
    // },
    // registro instalador PF
    async doRegisterSupplierPFAE(){
      this.showLoading(true, 'Realizando tu registro...')
      try {
        let payload = {
          user: this.$refs.userDataForm.getModel(),
          personal: this.$refs.personalProfile.getModel(),
          supplier: this.$refs.supplierForm.getModel(),
          from_referal: this.fromReferal,
          referal_code: this.fromReferal ? this.referalCode : null
        };

        await this.publicApiPost('/api/v2/preregister/supplierPFAE', payload);
        this.showSuccess();
      }
      catch (e) {
        this.showError(e);
      }
      this.showLoading(false)
    },
    // registro instalador PM
    async doRegisterSupplierPM(){
      this.showLoading(true, 'Realizando tu registro...')
      try {
        let payload = {
          user: this.$refs.userDataForm.getModel(),
          personal: this.$refs.personalProfile.getModel(),
          business: this.$refs.businessProfile.getModel(),
          supplier: this.$refs.supplierForm.getModel(),
          from_referal: this.fromReferal,
          referal_code: this.fromReferal ? this.referalCode : null
        };

        await this.publicApiPost('/api/v2/preregister/supplierPM', payload);
        this.showSuccess();
      }
      catch (e) {
        this.showError(e);
      }
      this.showLoading(false)
    },
    showSuccess(){
      this.activePrompt = true;
    },
    showError(e){
      this.warn(e)
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if(e.response && e.response.data && e.response.data.error){
        err = e.response.data.error;
      }
      this.errorMssg = err;
      this.errorNotif("Error en el registro", err, 10000);
    },
    async goToSelectType(){
      await this.$router.replace({name: 'nuevoRegistro', params: {type: 'inversionista'}});
      // Descomentar y eliminar la linea de arriba si se requiere seleccionar el registro porque la ruta infoRegistro esta comentada
      // await this.$router.replace({name: 'infoRegistro'});
    },
    async goToLogin(){
      await this.$router.replace({name: 'login'});
    },
    async goToRegisterNoCode(){
      await this.$router.replace({name: 'nuevoRegistro', params: {type: 'inversionista'}});
    },
    validateContracts(){
      if(this.contracts.allContracts !== true){
        this.errorMssg = "Debes aceptar los Términos y Condiciones y el Aviso de Privacidad.";
        return false;
      }
      return true;
    },
    resetForm(){
    },
    async goToLogin() {
      await this.$router.replace({ name: 'login' });
    },
    async goToSupplier() {
      // await this.$router.replace({ name: 'nuevoRegistro', params: { type: 'instalador' } });
      window.location = this.AppDomain + '/registro/instalador';
    },
    async goToOnboardingSelected() {

      if(this.productSelected === 3) {
        this.goToSupplier();
        return;
      }
      // await this.$router.replace({ name: 'nuevoRegistro', params: { type: 'instalador' } });
      let onboraring = this.productSelected == 1 ? 'inversionista' : 'solicitante';
      window.location = this.AppDomain + '/registro/' + onboraring;
    },
  }
}
</script>

<style lang="css" scoped>
.radio-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.checkbox-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.register-option {
  margin: 1rem;
  padding: 2rem;
  background-color: #DDF2D6;
  border-radius: 22px;
  place-self: center;
  width: 10rem;
  height: 10rem;
  display: flow;
  text-align: -webkit-center;
  align-content: center;
}

.register-option img {
  width: 5rem;
  /* height: 100px; */
}
.register-option img.investor-icon {
  width: 4rem;
  /* height: 100px; */
}


  .active {
    border: solid 3px;
    border-color: #28de18;
    box-shadow: 0px 5px 15px -10px #3b3a3e;
  }
</style>
